module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAMAAABFjsb+AAAAUVBMVEXU1NTc3Nzc3NzV1dXc3Nzc3Nzc3Nzc3Nzc3Nzc3NzOzs7Pz8/c3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3NwAAADOzs7R0dHY2NjX19fV1dXc3NyvJNJbAAAAFXRSTlPGYVm+PAdBDZGd8+kqI3VrCpAGAQBuo5toAAAAa0lEQVR42oXQSQ6AIAxAUUQQkBkce/+DCokLoIn+5QskbcmG+7QQEzJ3+tHMCtr2lhUAyNzZshc7WGuCQG3mjU3XXbvoz3z0fTc1xmeoEdH+ZUehfennk8VU7vewGlYz7utPh26QYvi+H+4BXNAbbZxn3ecAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// /opt/app/develop/src/assets/img/jquery.datatables/sort_both.png
// module id = ../../../../../src/assets/img/jquery.datatables/sort_both.png
// module chunks = 2